import angular from 'angular';
import uiRouter from 'angular-ui-router';
import CashboxTransfersComponent from './cashbox-transfers.component';
import dataTable from 'angular-material-data-table';

let CashboxTransfersModule = angular.module('cashbox-transfers', [
    uiRouter,
    dataTable
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('cashboxTransfers', {
        url: '/cashbox-transfers',
        component: 'cashboxTransfers',
        parent: 'main',
        data: {
            permissions: {
                only: ['AUTHORIZED'],
                redirectTo: 'home'
            }
        },
        resolve: {
            cashboxes: (CashboxesService) => {
                return CashboxesService.find({
                    include: ['employee'],
                    order: 'id DESC'
                });
            }
        }
    });
})
.component('cashboxTransfers', CashboxTransfersComponent)
.name;

export default CashboxTransfersModule;
